/*
  Together Games - silent discount auto-apply.
  Reads ?discount= / ?kod= / ?rabat= / ?promo= and applies the code via /discount/{code}
  once per browser session. Unknown codes are ignored. The confirmation modal was removed
  2026-09-14 (visitors left the page when it opened); it is in git history if ever needed.
*/
(function () {
  'use strict';

  var APPROVED_CODES = [
    'SPARK10',
    'SPARK15',
    'PAULA15',
    'NIECHZAISKRZY',
    'POPCORN-PREORDER',
    'POPCORN10',
    'POPCORN15',
    'OWCE10',
    'POPCORNOWEOWCE15',
    'TOGETHER15',
  ];
  var STORAGE_KEY = 'tg_discount_applied';

  function getDiscountParam() {
    try {
      var params = new URLSearchParams(window.location.search);
      var code =
        params.get('discount') ||
        params.get('kod') ||
        params.get('rabat') ||
        params.get('promo');
      return code ? code.trim().toUpperCase() : null;
    } catch (e) {
      return null;
    }
  }

  function isApproved(code) {
    return (
      APPROVED_CODES.indexOf(code) !== -1 ||
      /^SPARK\d+$/.test(code) ||
      /^POPCORN\d*$/.test(code) ||
      /^POPCORN-VIP-[A-Z0-9]+$/.test(code) ||
      /^OWCE\d*$/.test(code)
    );
  }

  function applyDiscount() {
    var code = getDiscountParam();
    if (!code || !isApproved(code)) return;

    try {
      if (sessionStorage.getItem(STORAGE_KEY) === code) return;
    } catch (e) {}

    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
    }).catch(function () {});

    try {
      sessionStorage.setItem(STORAGE_KEY, code);
    } catch (e) {}

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'discount_auto_applied', {
        discount_code: code,
        modal_shown: false,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDiscount);
  } else {
    applyDiscount();
  }
})();
